import axiosPublicClient from "../../../../../../axiosPublicClient"

const service = async ({ requestKey, file, fileName, fileExtension }) => {

    const response = await axiosPublicClient.post('/pre-check-additional-document-media-url', {
        key: requestKey,
        fileName,
        fileExtension,
    })

    if (!response?.data?.url || !response?.data?.key) {
        throw new Error('Upload URL or key missing from response')
    }

    const { url, key: assetKey } = response.data

    await axiosPublicClient.put(url, file, {
        headers: {
            'Content-Type': file.type,
        },
    })

    return { key: assetKey }
}

export default service
